/**
 * @description 會員註冊 step 2 性別用
 */
export enum SignupGender {
  /** 男性 */
  Male = 'M',
  /** 女性 */
  Female = 'F'
}
